import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { ScrollArea } from "@/components/ui/scroll-area";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import { WarningCircle, Warning, Info } from "@phosphor-icons/react";

const severityConfig = {
  critical: {
    badge: "destructive",
    icon: WarningCircle,
    color: "text-red-400",
  },
  warning: { badge: "default", icon: Warning, color: "text-amber-400" },
  info: { badge: "secondary", icon: Info, color: "text-teal-400" },
};

export default function AlertHistory({ alerts }) {
  return (
    <Card
      data-testid="alert-history"
      className="bg-zinc-900 border-zinc-800 rounded-sm p-4"
    >
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-xs font-bold uppercase tracking-[0.2em] text-zinc-400">
          Alert History
        </h3>
        <Badge
          variant={alerts.length > 0 ? "destructive" : "outline"}
          className="text-xs"
        >
          {alerts.length} alerts
        </Badge>
      </div>

      <ScrollArea className="h-[460px]">
        {alerts.length === 0 ? (
          <div className="text-center py-16">
            <Warning
              size={36}
              weight="duotone"
              className="text-zinc-700 mx-auto mb-3"
            />
            <p className="text-xs text-zinc-600">
              No alerts - all readings within thresholds
            </p>
          </div>
        ) : (
          <Table>
            <TableHeader>
              <TableRow className="border-zinc-800 hover:bg-transparent">
                <TableHead className="text-xs text-zinc-500 w-[90px]">
                  Severity
                </TableHead>
                <TableHead className="text-xs text-zinc-500">Type</TableHead>
                <TableHead className="text-xs text-zinc-500">
                  Message
                </TableHead>
                <TableHead className="text-xs text-zinc-500 text-right w-[60px]">
                  Value
                </TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {alerts.slice(0, 100).map((alert) => {
                const config =
                  severityConfig[alert.severity] || severityConfig.info;
                const Icon = config.icon;
                return (
                  <TableRow
                    key={alert.id}
                    className="border-zinc-800 hover:bg-zinc-800 transition-colors duration-150"
                  >
                    <TableCell>
                      <div className="flex items-center gap-1.5">
                        <Icon
                          size={14}
                          weight="duotone"
                          className={config.color}
                        />
                        <Badge
                          variant={config.badge}
                          className="text-[10px] px-1.5"
                        >
                          {alert.severity}
                        </Badge>
                      </div>
                    </TableCell>
                    <TableCell className="text-xs text-zinc-400 font-mono">
                      {alert.alert_type?.replace(/_/g, " ")}
                    </TableCell>
                    <TableCell className="text-xs text-zinc-300 max-w-[220px] truncate">
                      {alert.message}
                    </TableCell>
                    <TableCell className="text-xs text-right font-mono text-zinc-300">
                      {alert.value}
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        )}
      </ScrollArea>
    </Card>
  );
}
